<template>
    <div class="paginationArea">
        <nav>
            <ul class="pagination">
                <template v-if="1==mode">
                    <li class="page-item" style="margin-right: 24px"
                        v-bind:class="{ disabled: pageNumberNow === 1 }">
                        <a class="page-link" aria-label="Previous" @click="onPreviousClick">
                            <span aria-hidden="true">前へ</span>
                        </a>
                    </li>
                    <div class="d-flex flex-row align-items-center">
                        <div class="select-icon">
                            <select class="page-select input-text-scv over-text"
                                    v-model.number="pageNumberNow"
                                    @change="onPageSelectChange"
                                    style="min-width:70px;">
                                <option v-for="num in totalPageNum" v-bind:value="num" v-bind:key="num">{{ num }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="page-text flex-row align-items-center">
                        <div>/ {{totalPageNum}}</div>
                    </div>
                    <li class="page-item"
                        v-bind:class="{ disabled: pageNumberNow === totalPageNum }">
                        <a class="page-link" aria-label="Next" @click="onNextClick">
                            <span aria-hidden="true">次へ</span>
                        </a>
                    </li>
                </template>
                <template v-else>
                    <li class="page-item"
                        v-bind:class="{ disabled: pageNumberNow === 1 }">
                        <a class="page-link" aria-label="First" @click="onFirstClick">
                            <div class="d-flex align-items-center justify-content-center" style="height: 100%" aria-hidden="true">
                                <div class="icon-font-size">
                                    <i class="icon-page_first"></i>
                                </div>
                            </div>
                        </a>
                    </li>
                    <li class="page-item"
                        v-bind:class="{ disabled: pageNumberNow === 1 }">
                        <a class="page-link" aria-label="Previous" @click="onPreviousClick">
                            <span aria-hidden="true">前へ</span>
                        </a>
                    </li>
                    <template v-for="num of totalPageNum" :key="num">
                        <li v-if="isEnablePageNum(num)"
                            class="page-item"
                            v-bind:class="{ active: pageNumberNow === num }">
                            <a class="page-link" @click="onPageNumberClick(num)">{{ num }}</a>
                        </li>
                    </template>
                    <li class="page-item"
                        v-bind:class="{ disabled: pageNumberNow === totalPageNum }">
                        <a class="page-link" aria-label="Next" @click="onNextClick">
                            <span aria-hidden="true">次へ</span>
                        </a>
                    </li>
                    <li class="page-item"
                        v-bind:class="{ disabled: pageNumberNow === totalPageNum }">
                        <a class="page-link" aria-label="Last" @click="onLastClick">
                            <div class="d-flex align-items-center justify-content-center" style="height: 100%" aria-hidden="true">
                                <div class="icon-font-size">
                                    <i class="icon-page_last"></i>
                                </div>
                            </div>
                        </a>
                    </li>
                </template>
            </ul>
        </nav>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";

    @Options({
        props: {
            totalPageNum: Number,
            mode: { type: Number, default: 0 }, // 0：いつもの 1：スリム表示
        },
    })

    export default class PaginationUtil extends Vue {
        private pageNumberNow = 1;       // 現在表示中のページ番号
        private totalPageNum!: number;   // 総ページ数
        private maxPageNum = 8;          // 表示する最大のページ数

        public onPageNumberClick(clickNumber: number): void {
            this.pageNumberNow = clickNumber;
            this.$emit("pageNumberClicked", this.pageNumberNow);
        }

        public onPreviousClick(): void {
            if (1 !== this.pageNumberNow) {
                this.pageNumberNow = this.pageNumberNow - 1;
                this.$emit("pageNumberClicked", this.pageNumberNow);
            }
        }

        public onNextClick(): void {
            if (this.totalPageNum !== this.pageNumberNow) {
                this.pageNumberNow = this.pageNumberNow + 1;
                this.$emit("pageNumberClicked", this.pageNumberNow);
            }
        }

        public onFirstClick(): void {
            this.pageNumberNow = 1;
            this.$emit("pageNumberClicked", this.pageNumberNow);
        }

        public onLastClick(): void {
            this.pageNumberNow = this.totalPageNum;
            this.$emit("pageNumberClicked", this.pageNumberNow);
        }

        /**
         * @brief	ページ番号をリセットする。
         * @return	なし
         */
        public resetPageNumber(): void {
            this.pageNumberNow = 1;
        }

        /**
         * @brief	ページ番号を設定する
         * @return	なし
         */
        public setPageNumber(pageNumber: number): void {
            this.pageNumberNow = pageNumber;
        }

        /**
        * @brief	ページ番号を表示するかどうかを取得する。
        * @return	true:表示する false:表示しない
        */
        private isEnablePageNum(pageNum: number) {
            const startPage = Math.max(1, this.pageNumberNow - (this.maxPageNum / 2) + 1);
            const endPage = Math.min(this.totalPageNum, startPage + this.maxPageNum - 1);
            return (startPage <= pageNum) && (pageNum <= endPage);
        }

        /**
         * @brief	表示ページSelect変更イベント
         * @param   [in]    event           イベント
         * @return	なし
         */
        public onPageSelectChange(event: any) {
            this.pageNumberNow = parseInt(event.target.value);
            this.$emit("pageNumberClicked", this.pageNumberNow);
        }
    }
</script>

<style scoped>
    .paginationArea {
        
    }

    .pagination {
        margin-bottom: 0px;
        column-gap: 8px;
    }

    /* ************
     * ページネーション
     * ************/
    .page-link {
        cursor: pointer;
    }
    .page-link:focus {
        outline: none;
        box-shadow: none;
    }

    li.page-item {
        background-color: #fff;
        text-align: center;
    }

        li.page-item > a.page-link {
            width: 44px;
            height: 44px;
            line-height: 44px;
            font-size: 13px;
            color: #242424;
            border-radius: 3px;
            border: 1px solid #C8CDDC;
            background-color: #fff;
            padding: 0px;
            margin: 0px;
        }

        li.page-item.disabled .page-link {
            border: 1px solid #e1e6f0;
            color: #c8cddc;
        }

        li.page-item.active .page-link {
            pointer-events: none;
            border-color: #1464B9;
            border-width: 0px 0px 4px 0px;
            border-radius: 0px;
            font-size: 13px;
            color: #242424;
            background-color: #F7FAFF;
        }

        li.page-item > a.page-link:hover {
            border: 1px solid #C8CDDC;
            background-color: #f5f5fa;
        }

        li.page-item > a.page-link:not(:disabled):not(.disabled):active {
            background-color: #C8CDDC;
        }

    .page-text {
        height: 44px;
        width: 40px;
        line-height: 44px;
        padding: 0px;
        margin: 0px;
    }
</style>